






















import { AppState } from "../shared/types/AppState";
import { Component, Vue } from "vue-property-decorator";
import Clickbutton from "@/components/Clickbutton.vue";
import Linkbutton from "@/components/Linkbutton.vue";
import Icon from "@/components/Icon.vue";
import Textbox from "@/components/Textbox.vue";
import TranslationsActionsPane from "@/components/TranslationsActionsPane.vue";
import TranslationsCompletion from "@/components/TranslationsCompletion.vue";
import TranslationsKeyValuePairRow from "@/components/TranslationsKeyValuePairRow.vue";
import TranslationsLocaleSelector from "@/components/TranslationsLocaleSelector.vue";
import TranslationsWidgetRow from "@/components/TranslationsWidgetRow.vue";

@Component(
{
	components: {
		Clickbutton,
		Linkbutton,
		Icon,
		Textbox,
		TranslationsActionsPane,
		TranslationsCompletion,
		TranslationsKeyValuePairRow,
		TranslationsLocaleSelector,
		TranslationsWidgetRow
	}
})

export default class List extends Vue
{
	model = {
		textbox: "Quick fox whatever something jump!",

		completion: 60.5,

		tkvpr: {
			k: "x",
			v: "y",
			vEnUs: "z"
		},

		locales: [
			"en-US",
			"en-UK",
			"da-DK",
			"ru-RU"
		],

		selectedLocale: "da-DK",

		state: AppState.Opened
	};

	log()
	{
		console.log(this.model.tkvpr);
		console.log(this.model.selectedLocale);
	}
}
